/* esm.sh - stats-gl@4.1.0 */
export * from "/*stats-gl@4.1.0/esnext/stats-gl.mjs";
export { default } from "/*stats-gl@4.1.0/esnext/stats-gl.mjs";
